/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ReactComponent as ExternalLinkIcon } from "cms/assets/icons/external-link.svg";

const FooterLandAck = () => {
    return (
        <div className="footer-land-ack">
            <p>
                We respectfully acknowledge that our headquarters are located on the unceded territories
                of the xʷməθkʷəy̓əm (Musqueam), Sḵwx̱wú7mesh Úxwumixw (Squamish), and səlilwətaɬ (Tsleil-Waututh) Nations.
                We also honour the diverse First Nations, Inuit, and Métis peoples who care for the lands
                and waters across Turtle Island. &nbsp;
                <a
                    href="https://cansolveckd.ca/network_updates/why-land-acknowledgments-matter-now-more-than-ever/"
                    target="_blank"
                >
                    Learn more about why land acknowledgements matter
                </a>
                {" "}<ExternalLinkIcon alt="external-link" />
            </p>
        </div>
    );
};

export { FooterLandAck };
